const Template = {
  Act: "",
  Socials: ["", ""],
  Time: "",
};

export const StageSchedule = {
  Schedule: [
    {
      Act: "The Tonics",
      Socials: ["https://www.instagram.com/thetonicsband/"],
      Time: "17:30-17:55",
    },
    {
      Act: "Cavalier",
      Socials: ["https://www.instagram.com/cavalier.band/","https://www.youtube.com/@Band.Cavalier"],
      Time: "18:05-18:30",
    },
    {
      Act: "Substate",
      Socials: ["https://www.instagram.com/substate.band/","https://www.tiktok.com/@substate.band"],
      Time: "18:40-19:05",
    },
    {
      Act: "Catch",
      Socials: ["https://www.instagram.com/catchband_/","linktr.ee/catchband"],
      Time: "19:15-19:40",
    },
    {
      Act: "The Expression",
      Socials: ["https://www.instagram.com/the.expression.band/"],
      Time: "19:50-20:15",
    },
    {
      Act: "The Blazers",
      Socials: ["https://www.instagram.com/theblaz3rs/","https://theblazersband.com/"],
      Time: "20:25-20:50",
    },
  ],
};
